;(() => {
    const wpMediaSelector = (callback) => {
        let mediaFrame;
        if(mediaFrame){
            mediaFrame.open();
            return;
        }
        // Define image_frame as wp.media object
        mediaFrame = wp.media({
            title: BPStory.selectMedia,
            multiple : false,
            library : {
                type : [
                    'image',
                    'video'
                ]
            }
        });
        mediaFrame.on('select', function() {
            var attachment = mediaFrame.state().get('selection').first().toJSON();
            callback(attachment);
        });
        mediaFrame.open();
    }

    let selectStoryBoxImage = document.querySelector('.bpstory-select-story-box-image');
    if (selectStoryBoxImage) {
        selectStoryBoxImage.addEventListener('click', () => {
            wpMediaSelector((attachment) => {
                document.getElementById('story_box_image').value = attachment.url;
                document.getElementById('story_box_image_preview').src = attachment.url;
            });
        });
    }

    let selectStoryMedia = document.querySelector('.bpstory-select-story-media');
    if (selectStoryMedia) {
        selectStoryMedia.addEventListener('click', () => {
            wpMediaSelector((attachment) => {
                document.querySelector('.bpstory-media-url').value = attachment.url;
            });
        });
    }

})();